// extracted by mini-css-extract-plugin
export default {"titleSub":"Style_titleSub__ETUjN","icon":"Style_icon__825aj","termAndConditionCard":"Style_termAndConditionCard__pyxzR","item":"Style_item__6ka0z","right":"Style_right__u0d-0"};